module.exports = __webpack_public_path__ + "static/paperwork-1b8a4df74390ae8c86f1191b5f440bf9.png";